import { Skeleton } from '@mui/material'
import { Box, styled } from '@mui/system'

const Container = styled('div')({
  padding: '16px',
  maxWidth: '800px',
  margin: '0 auto'
})

const Divider = styled('div')({
  height: '1px',
  backgroundColor: '#e0e0e0',
  margin: '16px 0'
})

const PreAuthSkeleton = () => (
  <Box className='w-full'>
    <Skeleton variant='text' width='60%' height={32} />
    <Skeleton variant='text' width='40%' height={24} style={{ marginTop: 8 }} />

    <div style={{ marginTop: 24 }}>
      <Skeleton variant='text' width='30%' height={20} />
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        {[1, 2, 3, 4, 5].map(item => (
          <Skeleton key={item} variant='rounded' width={120} height={24} />
        ))}
      </div>
    </div>

    <Divider />

    <Skeleton variant='text' width='40%' height={28} />
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginTop: 16
      }}
    >
      {[
        'Is Referral',
        'Transaction Date',
        'Pre Auth Ref. No.',
        'Related Pre Auth Request Identifier'
      ].map(item => (
        <div key={item}>
          <Skeleton variant='text' width='60%' height={20} />
          <Skeleton variant='text' width='80%' height={24} />
        </div>
      ))}
    </div>

    <Divider />

    <Skeleton variant='text' width='30%' height={28} />
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginTop: 16
      }}
    >
      {['Document', 'Date Ordered', 'Pre Auth Res. Identifier', 'Outcome'].map(
        item => (
          <div key={item}>
            <Skeleton variant='text' width='50%' height={20} />
            <Skeleton variant='text' width='70%' height={24} />
          </div>
        )
      )}
    </div>

    <Divider />

    <Skeleton variant='text' width='20%' height={28} />
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginTop: 16
      }}
    >
      {['Type professional', 'Pre Auth Res. Url', 'Status'].map(item => (
        <div key={item}>
          <Skeleton variant='text' width='50%' height={20} />
          <Skeleton variant='text' width='70%' height={24} />
        </div>
      ))}
    </div>

    <Divider />

    <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
      {['EDIT PRE AUTH', 'UCAF', 'FOLLOW UP'].map(item => (
        <Skeleton key={item} variant='rounded' width={120} height={36} />
      ))}
    </div>

    <Divider />

    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginTop: 16
      }}
    >
      {['TPA Name', 'Sub Type', 'Pre Auth Period'].map(item => (
        <div key={item}>
          <Skeleton variant='text' width='40%' height={20} />
          <Skeleton variant='text' width='60%' height={24} />
        </div>
      ))}
    </div>
  </Box>
)

export default PreAuthSkeleton
